<script lang="ts">
  import { mount, onMount } from 'svelte';

  import SpreadSheetHead from './partials/SpreadSheetHead.svelte';
  import SpreadSheetRow from './partials/SpreadSheetRow.svelte';

  const RenderingRowLimit = 100;

  interface Props {
    rows?: string[][];
    headers?: string[];
  }

  let { rows = [], headers = [] }: Props = $props();

  onMount(() => {
    (async () => {
      await renderRowsAsLazyAsync();
    })();
  });

  const renderRowsAsLazyAsync = async (): Promise<void> => {
    const actualRows = rows;

    let currentIndex = 0;
    while (currentIndex < actualRows.length) {
      const nextIndexPosition = currentIndex + RenderingRowLimit;
      const loadedRow = actualRows.slice(currentIndex, nextIndexPosition);

      const element = document.querySelector('#spreadsheet-tbody');
      if (!element) break;

      loadedRow.forEach((row) => {
        mount(SpreadSheetRow, { target: element, props: { row } });
      });
      currentIndex = nextIndexPosition;

      // Sometime the file has morethan 10K records there, when rendering the all items would cause
      // app slowness or freezing, so we need this Timeout is for give a UI to render the records
      // after the timeout we are rendering the another set of records, it will reduce the freezing issue
      // and load the file quiker
      await new Promise((resolve) =>
        setTimeout(() => {
          resolve(true);
        }, 1000)
      );
    }
  };
</script>

<div class="comp-spreadsheet-table">
  <table class="table">
    <SpreadSheetHead {headers} />
    <tbody id="spreadsheet-tbody"></tbody>
  </table>
</div>

<style>
  .comp-spreadsheet-table {
    width: 100%;
    max-height: 100%;
    height: calc(100vh - 134px);
  }
  .table {
    table-layout: fixed;
    border-collapse: collapse;
    min-width: 100%;
  }
</style>
